import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./TaskManager.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
// import fisiIconDrop from "../../images/FisTaskIcon.png";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import HttpClient from "../../utils/HttpClient";
import TaskSidebar from "./sidebar/TaskSidebar";
import EventSidebar from "./sidebar/EventSidebar";
import ProjectSidebar from "./sidebar/ProjectSidebar";
import TaskList from "./todolists/TaskList";
import EventList from "./todolists/EventList";
import ProjectList from "./todolists/ProjectList";
import ProjectListTeam from "./todolists/ProjectListTeam";
import TaskPopUp from "./TaskPopUp";
import EventPopUp from "./EventPopUp";
import ProjectPopUp from "./ProjectPopUp";
import { useLanguage } from "../../Providers/LanguageContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TaskListUser from "./todolists/TaskListUser";
import EventListUser from "./todolists/EventListUser";
import { useUserData } from "../../Providers/UserWrapper";
import GroupChart from "./GroupChart";
import KanbanBoard from "./KanbanBoard";
import GanttChart from "./GanttChart";
import UserPermission from "./UserPermission";
import Milestone from "./Milestone";
import InvoiceCreation from "./InvoiceCreation";
import ForeCasting from "./ForeCasting";
import ForeCastingTable from "./ForeCastingTable";
import RiskManagement from "./RiskManagement";
import ProgressChart from "./ProgressChart";
import SharingFile from "./SharingFile";
import { worldCurrencies } from "../../utils/currencies";
import MilestonePopUp from "./MilestonePopUp";
import DeviationPopup from "./DeviationPopup";
import toast from "react-hot-toast";
import PhasePopUp from "./PhasePopUp";
import { formatDateForInput } from "../../utils/convertDateToTimezone";
import { useSelector } from "react-redux";

function EventsCalender() {

  // designers code
  const localizer = momentLocalizer(moment);

  const navigate = useNavigate();
  const { language } = useLanguage();
  const { search } = useLocation();
  const { setIsLoading } = useUserData();

  const [modala, setModala] = useState(false);
  const [modalb, setModalb] = useState(false);
  const [modalc, setModalc] = useState(false);
  const [modald, setModald] = useState(false);
  const [modale, setModale] = useState(false);
  const [modalf, setModalf] = useState(false);
  const [taskDetailData, setTaskDetailData] = useState({});
  const [assignUserData, setAssignUserData] = useState([]);

  const [tabName, setTabName] = useState("Tasks");
  const [detailName, setDetailName] = useState("");
  const [dayType, setDayType] = useState("month");
  const [buttonName, setButtonName] = useState("");
  const [isSelectUser, setIsSelectUser] = useState(false);

  const [dateData, setDatedata] = useState(new Date());
  const [calenderEvent, setCalenderEvent] = useState([]);
  const [custNames, setCustNames] = useState([]);
  const [vendorName, setVendorName] = useState([]);

  const [isSubscribed, setIsSubscribed] = useState(false);

  // console.log('calenderEvent: ', calenderEvent);

  // returns tab details
  const tabDetailsMemo = useMemo(() => {
    switch (tabName) {
      case "Tasks":
        return "Task Details";
      case "Events":
        return "Events Details";
      case "Projects":
        return "Projects Details";
      default:
        return "";
    }
  }, [tabName]);


  // console.log("dayType: ", dayType);



  // returns tab details color
  const tabDetailsColorMemo = useMemo(() => {
    switch (detailName) {
      case "Task Details":
        return "clrTaskBtn ";
        break;
      case "Events Details":
        return "clrEventsBtn ";
        break;
      case "Projects Details":
        return "clrProjectBtn ";
        break;
      default:
        return "clrDefaultBtn";
    }
  }, [detailName]);


  // console.log("tabDetailsColorMemo", tabDetailsColorMemo)


  // getting assigned users
  const getAssignedUSer = async () => {
    const res = await HttpClient.requestData("user-management", "GET")
    // console.log("resUser", res);
    if (res && res?.status) {
      // setAssignUserData(res?.data?.filter(item => item?._id !== profileData?._id));
      console.log("user management: }}}}} ", res?.data);

      setAssignUserData(res?.data);
    }
  }

  // format assignUser data for searchable dropdown
  const selectAssignUserMemo = useMemo(() => {
    return assignUserData?.map(item => ({
      value: item?._id,
      label: item?.name + " " + item?.surName,
      // color: '#FF8B00'
    }
    ))
  }, [assignUserData])


  // *****big calender ***********
  const handleSelectSlot = (slotinfo) => {
    setDatedata(slotinfo);
  };
  const handleSelectDayType = (weekinfo) => {
    setDayType(weekinfo);
  };
  // *****end big calender ***********



  // get the week number of a year
  const getWeekNumber = (year, month, day) => {
    const currentDate = new Date(year, month, day);
    let startDate = new Date(currentDate.getFullYear(), 0, 1);
    let days = Math.floor((currentDate - startDate) /
      (24 * 60 * 60 * 1000));

    let weekNumber = Math.ceil(days / 7);
    return weekNumber;
  }



  // **********task List*********
  const [taskData, setTaskData] = useState({
    open: [],
    doing: [],
    done: [],
    ideas: [],
    onhold: [],
  });
  const [taskAllData, setTaskAllData] = useState([]);

  const [entireTaskData, setEntireTaskData] = useState({
    open: [],
    doing: [],
    done: [],
    ideas: [],
    onhold: [],
  });

  const [entireTaskAllData, setEntireTaskAllData] = useState([]);

  const getTaskData = async () => {
    const data = {
      dayType: dayType,
      day: dateData.getDate(),
      month: dateData.getMonth() + 1,
      year: dateData.getFullYear(),
      week: getWeekNumber(dateData.getFullYear(), dateData.getMonth(), dateData.getDate())
    };
    // console.log("dataaasdff", data)
    // return;
    const res = await HttpClient.requestData("view-task-eventDetails", "POST", data);
    console.log("ress", res)
    if (res && res?.status) {
      setTaskAllData(res?.data);

      setDragDropData(res?.data, "taskStatus", setTaskData);

    }
  };
  // **********end task todo List*********




  // **********Event List*********
  const [eventData, setEventData] = useState({
    open: [],
    doing: [],
    done: [],
    ideas: [],
    onhold: [],
  });
  const [eventAllData, setEventAllData] = useState([]);

  const getEventData = async () => {
    const data = {
      dayType: dayType,
      day: dateData.getDate(),
      month: dateData.getMonth() + 1,
      year: dateData.getFullYear(),
      week: getWeekNumber(dateData.getFullYear(), dateData.getMonth(), dateData.getDate())
    };
    // console.log("dataaasdff", data)
    const res = await HttpClient.requestData(
      "view-event-eventDetails",
      "POST",
      data
    );
    // console.log("ressecvenffs", res)
    if (res && res?.status) {
      setEventAllData(res?.data);

      setDragDropData(res?.data, "eventStatus", setEventData);

    }
  };
  // **********end Event  List*********

  // **********project List*********
  const [projectData, setProjectData] = useState({
    open: [],
    doing: [],
    done: [],
    ideas: [],
    onhold: [],
  });
  const [preojectAllData, setProjectAllData] = useState([]);

  const getProjecData = async () => {
    const data = {
      dayType: dayType,
      day: dateData.getDate(),
      month: dateData.getMonth() + 1,
      year: dateData.getFullYear(),
      week: getWeekNumber(dateData.getFullYear(), dateData.getMonth(), dateData.getDate())
    };

    const res = await HttpClient.requestData(
      "view-project-eventdetails",
      "POST",
      data
    );
    // console.log("ressecvenffsPP", res)
    if (res && res?.status) {
      setProjectAllData(res?.data);

      setDragDropData(res?.data, "projectStatus", setProjectData);

    }
  };
  // **********end project List*********


  // convert task, event, project data in drag and deop format
  const setDragDropData = (data, statusName, setData) => {
    const open = data?.filter((item) => item?.[statusName] === "open");
    const doing = data?.filter((item) => item?.[statusName] === "doing");
    const done = data?.filter((item) => item?.[statusName] === "done");
    const idea = data?.filter((item) => item?.[statusName] === "ideas");
    const onhold = data?.filter((item) => item?.[statusName] === "onhold");

    setData([
      {
        name: "Open",
        color: "#fff",
        status: open,
        apiStatus: "open",
      },
      {
        name: "Doing",
        color: "#fff",
        status: doing,
        apiStatus: "doing",
      },
      {
        name: "Done",
        color: "#fff",
        status: done,
        apiStatus: "done",
      },
      {
        name: "Ideas",
        color: "#fff",
        status: idea,
        apiStatus: "ideas",
      },
      {
        name: "On-hold",
        color: "#fff",
        status: onhold,
        apiStatus: "onhold",
      },
    ]);
  };


  useEffect(() => {
    getTaskData();
    getEventData();
    getProjecData();
  }, [dayType, dateData]);


  const getDateTimeFormat = useCallback((date, time) => {
    const year = moment(date).year();
    const month = moment(date).month();
    const day = moment(date).date();
    const hour = time?.split(":")?.[0];
    const minute = time?.split(":")?.[1];

    // console.log("dateTimeDate", new Date(year, month, day, hour, minute), date, year, month, day, hour, minute)
    return new Date(year, month, day, hour, minute);

    // console.log("dateTime", moment(date).year(), moment(date).day(), moment(date).month(), time?.split(":")?.[0], time?.split(":")?.[1])
  }, [])


  const getLocalDateOnly = useCallback((date) => {
    if (!date) return null;
    // Create a new date object and set hours to 0 to get just the date part
    const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }, []);

  const addOneDay = useCallback((d) => {
    if (!d) return null;
    const nd = new Date(d);
    nd.setDate(nd.getDate() + 1);
    return nd;
  }, []);

  // set events of calender
  const SetEventsOfCalender = () => {
    setCalenderEvent([]);

    const arr = taskAllData?.map((item) => ({
      title: item?.taskName,
      // start: new Date(item?.selectDate),
      start: getDateTimeFormat(item?.selectDate, item?.startTime),
      end: getDateTimeFormat(item?.selectDate, item?.endTime),
      details: item,
      tabName: "Tasks"
    }));
    const arr2 = eventAllData?.map((item) => ({
      title: item?.eventName,
      start: getDateTimeFormat(item?.selectDate, item?.startTime),
      end: getDateTimeFormat(item?.selectDate, item?.endTime),
      details: item,
      tabName: "Events"
    }));
    const arr3 = preojectAllData?.map((item) => ({
      title: item?.projectName,
      start: new Date(item?.startDate),
      end: new Date(item?.endDate),
      details: item,
      tabName: "Projects"
    }));
    // const arr3 = preojectAllData?.map((item) => {
    //   const startLocal = getLocalDateOnly(item?.startDate);
    //   // bump end by +1 day because RBC end is exclusive
    //   const endInclusive = addOneDay(getLocalDateOnly(item?.endDate));
    //   return {
    //     title: item?.projectName,
    //     start: startLocal,
    //     end: endInclusive,
    //     details: item,
    //     tabName: "Projects",
    //   };
    // });
    setCalenderEvent([...arr, ...arr2, ...arr3]);
  }
  useEffect(() => {
    SetEventsOfCalender(taskAllData, eventAllData, preojectAllData)
  }, [taskAllData, eventAllData, preojectAllData]);


  // console.log("calenderEventsdf", calenderEvent, taskAllData);


  // **************** google calender apis *******************
  const getGoogleEvent = async () => {
    const queryParamData = convertQueryParamsStringToQueryParamsObject(search)
    console.log("queryParamData",);
    const decodedValue = JSON.parse(decodeURIComponent(decodeURIComponent(queryParamData.state)))
    console.log("decodedValue", decodedValue)
    if (decodedValue.type == 'google') {
      const res = await HttpClient.requestData(`google-auth/callback?code=${queryParamData?.code}&state=${queryParamData?.state}`, "GET")
    } else if (decodedValue.type == 'outlook') {
      const res = await HttpClient.requestData(`outlook-auth/callback?code=${queryParamData?.code}&state=${queryParamData?.state}`, "GET")
    }
    // 
    // console.log("resdfrgrefd", res)
  }

  const convertQueryParamsStringToQueryParamsObject = (string) => {
    let queryParams = {};
    // remove first letter from query string
    string = string.substring(1);
    // console.log("string", string);
    // convert string to array
    const queryParamsArray = string.split("&");
    // console.log("queryParamsArray", queryParamsArray);

    // covert each index query to object
    queryParamsArray.forEach((queryParam) => {
      // console.log("queryParam", queryParam);
      // split param by =
      const queryParamArray = queryParam.split("=");
      // console.log("queryParamArray", queryParamArray);
      queryParams[queryParamArray[0]] = queryParamArray[1];
      // console.log("queryParams", queryParams);
    });
    return queryParams;
  };

  const GoogleCalenderSynced = async () => {
    const res = await HttpClient.requestData("google-calender-data", "GET")
    // console.log("resgvvb", res)
  }

  useEffect(() => {
    if (search) {
      getGoogleEvent()
    }
  }, [search])
  // **************** End google calender apis *******************



  // color of event in calender
  const eventStyleGetter = (event) => {

    const bgColor = () => {
      switch (event?.tabName) {
        case "Tasks": return "#729FCF"; break;
        case "Events": return "#F6B4CA"; break;
        case "Projects": return "#A1467E"; break;
        default: return "#729FCF"
      }
    }

    return {
      style: {
        backgroundColor: bgColor(), // Default background color for events
        borderRadius: "5px",
        color: "white",
        border: "none",
        display: "block",
        fontSize: "13px",
        // height: "50px"
      },
    };

  };


  // click on event in calender
  const handleClickEvent = (event, e) => {
    // console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAaaaa");
    setTaskDetailData({ ...event?.details, tabName: event?.tabName });

    switch (event?.tabName) {
      case "Tasks":
        setModala(true);
        break;
      case "Events":
        setModalb(true);
        break;
      case "Projects":
        setModalc(true);
        break;
      default:
        setModala(false);
        setModalc(false);
        setModalb(true);
        break;
    }
  };

  /** ... fetch Entire Tasks list for Khanban Chart ... **/
  const fetchEntireTask = async () => {
    try {
      const res = await HttpClient.requestData("getAllTasks", "GET");
      if (res?.success) {
        const data = res.data
          .filter(task => task.assignToProject != null) // checks for both null and undefined
          .map(item => ({
            ...item,
            // assignToUser: item.assignToUser?._id,
            assignToUser: item.assignToUser?.length > 0 ? item?.assignToUser?.map(item => item?._id) : [],
            assignToProject: item.assignToProject?._id,
          }));

        setDragDropData(data, "taskStatus", setEntireTaskData);
        // console.log("Entire Task Data???????: ", res?.data);
        setEntireTaskAllData(res?.data?.map(item => ({
          ...item,
          assignToUser: item.assignToUser?.length > 0 ? item?.assignToUser?.map(item => item?._id) : [],
          assignToProject: item.assignToProject?._id,
        })));
      }
    } catch (error) {
      toast.error(error.message || "Error fetching tasks");
    }
  };

  useEffect(() => {
    fetchEntireTask();
  }, []);

  // console.log("entireTaskData>>>>>>>||||| ", entireTaskData);


  // clicks on select user dropdown
  const handleClickSubUser = async (item) => {
    // console.log("objeitemsubuct", item, tabName)
    const data = {
      selectedUser: item?._id,
      dayType: dayType,
      day: dateData.getDate(),
      month: dateData.getMonth() + 1,
      year: dateData.getFullYear(),
      week: getWeekNumber(dateData.getFullYear(), dateData.getMonth(), dateData.getDate())
    }
    setIsSelectUser(false)
    setIsLoading(true)
    const res = await HttpClient.requestData("view-user-task-eventDetails", "POST", data);
    if (res && res?.status) {
      // console.log("ressTask", res)
      setTaskAllData(res?.data);
      setDragDropData(res?.data, "taskStatus", setTaskData);
      setIsLoading(false)
    } else {
      setIsLoading(false)
    }

    const res2 = await HttpClient.requestData("view-user-event-eventDetails", "POST", data);
    if (res2 && res2?.status) {
      // console.log("ressTask", res)
      setEventAllData(res2?.data);
      setDragDropData(res2?.data, "eventStatus", setEventData);
      setIsLoading(false)
    } else {
      setIsLoading(false)
    }

    const res3 = await HttpClient.requestData("view-user-project-eventdetails", "POST", data);
    if (res3 && res3?.status) {
      // console.log("ressTask", res3)
      setProjectAllData(res3?.data);
      setDragDropData(res3?.data, "projectStatus", setProjectData);
      setIsLoading(false)
    } else {
      setIsLoading(false)
    }

  }

  const viewAllCalData = () => {
    setIsSelectUser(false);
    getTaskData();
    getEventData();
    getProjecData();
  }


  // remove duplicate from array of object
  const removeDuplicateFunc = (arr, key) => {
    const unique = arr.filter((obj, index) => {
      return index === arr.findIndex(o => obj[key] === o[key]);
    });
    return unique;
  }

  // get customer, vendor data
  const getCustomerVendor = async () => {
    const data1 = {
      input_type: "Customer"
    }
    const res1 = await HttpClient.requestData("get-dashboard-zero-bu-input-data", "POST", data1);
    if (res1 && res1?.success) {
      const filtData = removeDuplicateFunc(res1?.data, "customerName")
      setCustNames(filtData)
      // case "Vendor":
      // const filtData2 = removeDuplicateFunc(res?.data, "vendorName")
      // setCustData(filtData2)
    }

    const data2 = {
      input_type: "Vendor"
    }
    const res2 = await HttpClient.requestData("get-dashboard-zero-bu-input-data", "POST", data2);
    if (res2 && res2?.success) {
      const filtData2 = removeDuplicateFunc(res2?.data, "vendorName")
      setVendorName(filtData2)
    }

  }

  // format customer Vendor data for searchable dropdown
  const selectCustVendorMemo = useMemo(() => {
    const cust = custNames?.map(item => ({
      value: item?.customerName,
      label: item?.customerName,
    }))
    const vendor = vendorName?.map(item => ({
      value: item?.vendorName,
      label: item?.vendorName,
    }))
    return [...cust, ...vendor]
  }, [custNames, vendorName])


  const selectCurrencyMemo = useMemo(() => {
    return worldCurrencies?.map(curr => ({
      value: curr?.code,
      label: curr?.code,
    }));
  }, []);


  useEffect(() => {
    GoogleCalenderSynced();

    getAssignedUSer();
    getCustomerVendor();
  }, [])
  const [newFeatures, setNewFeatures] = useState(false);
  const { togglePath, } = useParams();

  const [Features, setFeatures] = useState({
    toggle0: true,
    toggle1: false,
    toggle2: false,
    toggle3: false,
    toggle4: false,
    toggle5: false,
    toggle6: false,
    toggle7: false,
    toggle8: false,
    toggle9: false,
    toggle10: false,
  });

  const Settoggle = (i) => {
    setFeatures({

      toggle1: i === 0 ? true : false,
      toggle2: i === 1 ? true : false,
      toggle3: i === 2 ? true : false,
      toggle4: i === 3 ? true : false,
      toggle5: i === 4 ? true : false,
      toggle6: i === 5 ? true : false,
      toggle7: i === 6 ? true : false,
      toggle8: i === 7 ? true : false,
      toggle9: i === 8 ? true : false,
      toggle10: i === 9 ? true : false,
    })
  };

  useEffect(() => {
    if (togglePath === "toggle5") {
      setFeatures({
        toggle1: false,
        toggle2: false,
        toggle3: false,
        toggle4: false,
        toggle5: true,
        toggle6: false,
        toggle7: false,
        toggle8: false,
        toggle9: false,
        toggle10: false,
      });
    }
  }, [togglePath]);
  const { kanbanData } = useSelector(state => state?.favDashboard);

  const handleKanbanRedirectDirectly = async () => {
    if (location?.pathname !== "/eventsCalender") {
      await fetchEntireTask();
      await fetchEntireTask();
      setFeatures({
        toggle0: false,
        toggle1: false,
        toggle2: true,
        toggle3: false,
        toggle4: false,
        toggle5: false,
        toggle6: false,
        toggle7: false,
        toggle8: false,
        toggle9: false,
        toggle10: false,
      });
    }
  };

  useEffect(() => {
    if (kanbanData) {
      handleKanbanRedirectDirectly();
    }
  }, [kanbanData]);
  console.log("kanbanData: ", kanbanData);


  // console.log('Features: ', Features);


  const [flag, setFlag] = useState(6);

  //  const HandleCLickOutside = () =>{
  //   setNewFeatures(false)
  // }

  //  useEffect(()=>{

  //   document.body.addEventListener('mousedown',HandleCLickOutside)

  //  },[])

  const checkUserSubscription = async () => {
    try {
      const res = await HttpClient.requestData('isSubccribedornot', 'GET');
      if (res && res?.status) {
        setIsSubscribed(res?.isSubscribed);
      }
    } catch (error) {
      toast.error(error?.message || 'something went wrong!!!');
    }
  };

  useEffect(() => {
    checkUserSubscription();
  }, []);

  console.log("Features: ", Features);

  const dropdownRef = useRef()
  const selectUserRef = useRef()
  useEffect(() => {
    const HandleCLickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setNewFeatures(false)
      } else if (
        selectUserRef.current && !selectUserRef.current.contains(e.target)
      ) {
        setIsSelectUser(false)
      }

    }
    document.addEventListener('mousedown', HandleCLickOutside)
  }, [])

  useEffect(() => {
    window.scrollTo({ top: '0', behavior: 'instant' });
  }, [Features]);

  // Later, when parsing dates, force UTC like:
  const toUTCDate = (dateStr) => moment.utc(dateStr).toDate();

  // Then normalize events:
  const normalizedEvents = calenderEvent.map(event => ({
    ...event,
    // start: event.tabName === "Projects" ?  new Date(formatDateForInput(event?.details.startDate, event?.details?.timeZone)) : new Date(formatDateForInput(toUTCDate(event.selectDate || event.start), event?.details?.timeZone)),
    // end: event.tabName === "Projects" ?  new Date(formatDateForInput(event?.details?.endDate, event?.details?.timeZone)) : new Date(formatDateForInput(toUTCDate(event.end), event?.details?.timeZone)),
    start: toUTCDate(event.selectDate || event.start),
    end: toUTCDate(event.end),
  }));
  const location = useLocation();
  // console.log("calenderEvent>>>>>>???????: ", calenderEvent);

  // console.log("normalizedEvents>>>>>>???????: ", normalizedEvents);

  console.log("togglePath: ", togglePath);

  return (
    <>
      <div >
        {
          location?.pathname === "/eventsCalender" && (
            <div className="try_fisibilty_wrapper">
              {
                !isSubscribed && (
                  <>
                    <p>Try Fisibility Now !</p>
                    <button >FREE USER LICENSE</button>
                  </>
                )
              }
            </div>
          )
        }
        <section className={Features.toggle0 ? " evntsCalSection" : Features.toggle6 ? " evntsCalSection" : Features.toggle7 ? " evntsCalSection" : Features.toggle10 ? " evntsCalSection" : "evntsCalSection section_bg"} style={{
          paddingTop: location?.pathname === "/eventsCalender" ? '50px' : '0px',
          background: location?.pathname === "/eventsCalender" ? "linear-gradient(rgb(15, 36, 55), rgb(255, 255, 255))" : "none",
        }}>
          <div className="container-fluid">
            {/* <div className=''>
            <button className='w-25 mb-2 btn btn-outline-success' style={{ fontWeight: "bold" }} onClick={() => navigate('/connectCalender')}>
              {language.connect_my_calendar}
            </button>
          </div> */}
            {/* <div className="row mb-3">
            <div className="col">
              <div className="takEvntDiv">
                <span className="takEvntText">{language.task_event_manager}</span>
              </div>
            </div>
          </div> */}
            {
              location?.pathname !== "/favourite-dashboard" && togglePath === undefined && (
                <div style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: "center",

                }}>
                  <div className="detailBtnGroups" style={{
                    display: 'flex',
                    columnGap: '10px'

                  }}>
                    {!Features.toggle0 && <div style={{
                      position: 'relative',
                      marginRight: '50px'
                    }}>
                      <button

                        className={`slctUser mr-2 }`}
                        style={{
                          color: '#0c2637',
                          background: '#88e984',
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          columnGap: '10px'
                        }}
                        onClick={(() => {
                          // window.location.reload();
                          setFeatures({
                            toggle0: true,
                            toggle1: false,
                            toggle2: false,
                            toggle3: false,
                            toggle4: false,
                            toggle5: false,
                            toggle6: false,
                            toggle7: false,
                            toggle8: false,
                            toggle9: false,
                            toggle10: false,
                          });
                          setFlag(6);
                        })}
                      >
                        <i class="fa-solid fa-arrow-left"></i>
                        Calendar
                      </button>
                    </div>}
                    <div style={{
                      position: 'relative',
                    }}>
                      <button
                        style={{
                          background: '#e9ebed',
                          color: '#0c2637'
                        }}
                        onClick={() => setModale(true)}
                        className={`slctUser mr-2 ${(flag !== 6 && flag !== 5) && ' slctUser_white'}`}
                      >
                        Deviation
                      </button>
                    </div>


                    <div style={{
                      position: 'relative',
                    }}>
                      <button
                        style={{
                          background: '#e9ebed',
                          color: '#0c2637'
                        }}
                        onClick={() => setModalf(true)}
                        className={`slctUser mr-2 ${(flag !== 6 && flag !== 5) && ' slctUser_white'}`}
                      >
                        Phase
                      </button>
                    </div>

                    <div style={{
                      position: 'relative',
                    }}>
                      <button
                        style={{
                          background: '#e9ebed',
                          color: '#0c2637'
                        }}
                        onClick={() => setModald(true)}
                        className={`slctUser mr-2 ${(flag !== 6 && flag !== 5) && ' slctUser_white'}`}
                      >
                        Create Milestone
                      </button>
                    </div>

                    <div style={{
                      position: 'relative',
                    }} >
                      <button
                        style={{
                          background: '#e9ebed',
                          color: '#0c2637'
                        }} onClick={(() => setNewFeatures(!newFeatures))}
                        className={Features.toggle0 ? "slctUser" : Features.toggle6 ? "slctUser" : Features.toggle7 ? "slctUser" : Features.toggle10 ? "slctUser" : ' slctUser_white'}>
                        Project Intelligence
                      </button>


                      {/* {newFeatures && (
                    <div className="selectUserCelDrop">
                      {['Kanban Board Analytics',
                        'Gantt chart', 'Invoice creation', 'Progress chart ',
                        'User access project wise', 'Milestone creation',
                        'Risk management', 'Forecasting', 'File sharing'].map((e, i) => {
                          return (
                            <>
                              <p  onClick={(() => {
                                Settoggle(i + 1);
                                setFlag(i + 1);
                                setNewFeatures(!newFeatures);
                              })}>{e}</p>
                            </>
                          )
                        })}

                    </div>
                  )} */}

                      {newFeatures && (
                        <div ref={dropdownRef} className="selectUserCelDrop">
                          {['Kanban Board Analytics',
                            'Gantt chart', 'Invoice creation', 'Risk management',
                            'Project Quick View', 'Milestone creation'].map((e, i) => {
                              return (
                                <>
                                  <p onClick={(() => {
                                    Settoggle(i + 1);
                                    setFlag(i + 1);
                                    setNewFeatures(!newFeatures);
                                  })}>{e}</p>
                                </>
                              )
                            })}

                        </div>
                      )}
                    </div>



                    <div style={{
                      position: 'relative',

                    }}>
                      <button

                        style={Features.toggle0 ? {} : Features.toggle6 ? {} : Features.toggle7 ? {} : Features.toggle10 ? {} : { background: '#F7F7F7', color: '#000' }}
                        className={`slctUser mr-2 bg-light text-dark ${buttonName === 'User' && tabDetailsColorMemo}`}
                        onClick={() => {
                          // setButtonName("User")
                          // setDetailName(tabDetailsMemo)
                          setIsSelectUser(prev => !prev);
                        }}
                      >
                        {language.Select_User}
                      </button>

                      {isSelectUser && (
                        <div ref={selectUserRef} className="selectUserCelDrop">
                          <p onClick={() => viewAllCalData()}>View All</p>
                          {assignUserData?.map((item, i) => (
                            <p key={i} className="" onClick={() => handleClickSubUser(item)}>
                              {item?.name + ' ' + item?.surName}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )
            }

            {/* Calendar And Calendar Form Starts From Here */}
            {Features.toggle0 && <div className="row">
              {
                location?.pathname !== "/favourite-dashboard" && (
                  <div className="col-lg-4 col-12">
                    {
                      togglePath === undefined && (
                        <div className="myTaskEvPrTabDiv">
                          <Tabs>
                            <TabList>
                              <Tab
                                onClick={() => {
                                  setTabName('Tasks');
                                  setDetailName('');
                                  setButtonName('');
                                }}
                              >
                                {language.task}
                              </Tab>
                              <Tab
                                onClick={() => {
                                  setTabName('Events');
                                  setDetailName('');
                                  setButtonName('');
                                }}
                              >
                                {language.events}
                              </Tab>
                              <Tab
                                onClick={() => {
                                  setTabName('Projects');
                                  setDetailName('');
                                  setButtonName('');
                                }}
                              >
                                {language.Projects}
                              </Tab>
                            </TabList>

                            {/* Task */}
                            <TabPanel>
                              <TaskSidebar
                                setModala={setModala}
                                getTaskData={getTaskData}
                                taskAllData={taskAllData}
                                setTaskDetailData={setTaskDetailData}
                                selectAssignUserMemo={selectAssignUserMemo}
                                entireTaskData={entireTaskAllData}
                                fetchEntireTask={fetchEntireTask}
                              />
                            </TabPanel>

                            {/* Events */}
                            <TabPanel>
                              <EventSidebar
                                setModalb={setModalb}
                                getEventData={getEventData}
                                eventAllData={eventAllData}
                                setTaskDetailData={setTaskDetailData}
                                selectAssignUserMemo={selectAssignUserMemo}
                                selectCustVendorMemo={selectCustVendorMemo}
                              />
                            </TabPanel>

                            {/* Projects */}
                            <TabPanel>
                              <ProjectSidebar
                                setModalc={setModalc}
                                getProjecData={getProjecData}
                                preojectAllData={preojectAllData}
                                setTaskDetailData={setTaskDetailData}
                                selectAssignUserMemo={selectAssignUserMemo}
                                selectCustVendorMemo={selectCustVendorMemo}
                                selectCurrencyMemo={selectCurrencyMemo}
                                getTaskData={getTaskData}
                                fetchEntireTask={fetchEntireTask}
                              />
                            </TabPanel>
                          </Tabs>
                        </div>
                      )
                    }
                  </div>
                )
              }

              <div className={(location?.pathname !== "/favourite-dashboard" && togglePath === undefined) ? "col-lg-8 col-12 mt-4 mt-lg-0" : "col-12 text-center"}>
                <div className="evntTaskCalenDiv">
                  {/* details buttons  */}
                  <div className="selectProBtnDiv">


                    {/* team / status for project */}
                    {buttonName !== '' ? (
                      <div>
                        <span className="dwmBtns dwmBtnsActive">
                          {buttonName === 'User' ? language.team : language.status}
                        </span>
                        <span
                          className="dwmBtns"
                          style={{ cursor: 'pointer' }}
                          onClick={() => setButtonName(prev => (prev === 'Detail' ? 'User' : 'Detail'))}
                        >
                          {'<'}
                        </span>
                        <span
                          className="dwmBtns"
                          style={{ cursor: 'pointer' }}
                          onClick={() => setButtonName(prev => (prev === 'Detail' ? 'User' : 'Detail'))}
                        >
                          {'>'}
                        </span>
                      </div>
                    ) : (
                      <div> </div>
                    )}

                    {/* right side buttons */}

                  </div>

                  <div>
                    {/* Big Calender */}
                    {detailName === '' && (
                      <div className="taskBigCalDiv">
                        <Calendar
                          localizer={localizer}
                          // events={calenderEvent}
                          events={normalizedEvents}
                          selectable={true}
                          onNavigate={handleSelectSlot} //for date
                          onView={handleSelectDayType} //for day type
                          startAccessor="start"
                          endAccessor="end"
                          style={{ height: '468px' }}
                          eventPropGetter={eventStyleGetter}
                          onSelectEvent={handleClickEvent}
                          showAllEvents={true}
                        // messages={{ agenda: "my Agenda Name" }}
                        // components={components}
                        // views={['month', 'day', 'agenda']}
                        />
                      </div>
                    )}

                    {/* Color Full Tab Part --> Don't delete the below part */}
                    {/* drag and drop part */}

                    {/* Task */}
                    {/* {buttonName === 'Detail' && detailName === 'Task Details' && (
                    <TaskList
                      setModala={setModala}
                      taskData={taskData}
                      getTaskData={getTaskData}
                      setTaskData={setTaskData}
                    />
                  )} */}

                    {/* {buttonName === 'User' && detailName === 'Task Details' && (
                    <TaskListUser allData={taskAllData} setAllData={setTaskAllData} />
                  )} */}



                    {/* Event */}
                    {buttonName === 'Detail' && detailName === 'Events Details' && (
                      <EventList eventData={eventData} getEventData={getEventData} setEventData={setEventData} />
                    )}

                    {buttonName === 'User' && detailName === 'Events Details' && (
                      <EventListUser allData={eventAllData} setAllData={setEventAllData} />
                    )}

                    {/* project */}
                    {buttonName === 'Detail' && detailName === 'Projects Details' && (
                      <ProjectList
                        projectData={projectData}
                        getProjecData={getProjecData}
                        setProjectData={setProjectData}
                      />
                    )}

                    {buttonName === 'User' && detailName === 'Projects Details' && (
                      <ProjectListTeam allData={preojectAllData} setProjectAllData={setProjectAllData} />
                    )}
                  </div>
                </div>
              </div>
            </div>}

            {/* {Features.toggle2 && (
                    <TaskListUser allData={taskAllData} setAllData={setTaskAllData} />
                  )} */}


            {/* Calendar And Calendar From Ends Here */}

            {Features.toggle1 && <GroupChart />}
            {/* {Features.toggle2 && <KanbanBoard />} */}
            {Features.toggle2 && <TaskList
              setModala={setModala}
              // taskData={taskData}
              taskData={entireTaskData}
              getTaskData={getTaskData}
              // setTaskData={setTaskData}
              setTaskData={setEntireTaskData}
              fetchEntireTask={fetchEntireTask}
              currentMonth={dateData.getMonth() + 1}
              currentYear={dateData.getFullYear()}
            />}
            {Features.toggle3 && <GanttChart />}
            {Features.toggle6 && <UserPermission getTaskData={getTaskData} fetchEntireTask={fetchEntireTask} />}
            {Features.toggle7 && <Milestone />}
            {Features.toggle4 && <InvoiceCreation />}
            {Features.toggle9 && <ForeCasting />}
            {Features.toggle5 && <RiskManagement setFeatures={setFeatures} />}
            {/* {Features.toggle5 && <ProgressChart />} */}
            {Features.toggle10 && <SharingFile />}
          </div>
        </section>
        <div className="container">
          {Features.toggle9 && <ForeCastingTable />}
        </div>

        {modala && <TaskPopUp closemodal={setModala} detailData={taskDetailData} getTaskData={getTaskData} fetchEntireTask={fetchEntireTask} isFromTaskList={false} />}

        {modalb && <EventPopUp closemodal={setModalb} detailData={taskDetailData} getEventData={getEventData} />}

        {modalc && <ProjectPopUp closemodal={setModalc} detailData={taskDetailData} getProjecData={getProjecData} />}

        {modald && <MilestonePopUp closeModal={setModald} getTaskData={getTaskData} taskAllData={taskAllData} />}

        {modalf && <PhasePopUp closeModal={setModalf} getTaskData={getTaskData} taskAllData={taskAllData} />}

        {modale && <DeviationPopup closeModal={setModale} getTaskData={getTaskData} taskAllData={taskAllData} />}
      </div>

    </>
  );
}

export default EventsCalender;
